import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-docusign-dialog',
  templateUrl: './confirm-docusign-dialog.component.html',
  styleUrls: ['./confirm-docusign-dialog.component.scss']
})
export class ConfirmDocusignDialogComponent {
    readonly dialogRef = inject(MatDialogRef<ConfirmDocusignDialogComponent>);
    readonly data = inject<DialogData>(MAT_DIALOG_DATA);

    confirmDialog(confirmDialog: boolean): void {
        this.dialogRef.close(confirmDialog);
    }
}

export interface DialogData {
    title: string;
    type: string;
    fileName: string;
}